export const FOOTNOTE_REFERENCES = {
    asterisk: '*',
    doubleAsterisk: '**',
    dagger: '†',
    doubleDagger: '‡',
    section: '§',
    pilcrow: '¶',
};